// extracted by mini-css-extract-plugin
export default {"container":"home_container__+ck0B","aboutContainer":"home_aboutContainer__bK5gz","flex":"home_flex__enKDV","leftSection":"home_leftSection__23SiS"};